import React, { Component } from "react";

//// componentes reutilizables
import Titulo from "../../generico/TituloPagina";
import CardEntidad from "./CardEntidad"
import PopupEntidadServicio from "./PopupEntidadServicio"
import PagoServicioService from "../../../services/pagoServicios/pagoServicioService";
import history from "../login/history";
import Select from "react-select";
import { trackPromise } from 'react-promise-tracker';
import ReactTooltip from "react-tooltip";
import Popup from "react-popup";
import authService from "../../../services/login/auth.service";
import ConfigService from "../../../services/configuracion/ConfigService";

export default class PagoServicio extends Component {
  constructor(props) {
    super(props);
    this.getCuentasSocio = this.getCuentasSocio.bind(this);
    this.getOptionsCuentas = this.getOptionsCuentas.bind(this);

    this.state = {
      cuentasOrigen: [],
      optionsCuentas: [],
      selectedOption: "",
      rubros: [],
      selectedRubro: "",
      valorRubroSelected: undefined,
      inputEntidad: "",
      loading: false,
      message: "",
      entidadesFiltrado: [],
      servicios: [],
      entidades: [],
      itemSelected: [],
      valor: "",
      pathEntidad: "",
      servicioSearch: undefined
    };
  }

  componentDidMount() {

    this.getServiciosDisponibles();
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  getOptionsCuentas(item) {
    var options = [];

    for (var i = 0; i < item.length; i++) {
      options.push({
        value: item[i].cuenta,
        label:
          item[i].cuenta +
          "-" +
          item[i].tipoDeCuenta +
          "-" +
          " Saldo: " +
          item[i].saldoActual + " " +
          item[i].moneda +
          ".",
      });
    }
    this.setState({ optionsCuentas: options });
  }


  getCuentasSocio() {
    trackPromise(
      PagoServicioService.getCuentasSocio()
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          if (jsonData.codRespuesta === '000') {
            this.setState({ cuentasOrigen: jsonData.respuestaDetalles });
            this.getOptionsCuentas(jsonData.respuestaDetalles);
          }
        },
          error => {
            const resMessage = error.codDescripcion;
            this.setState({
              loading: false,
              message: resMessage
            });
            //  this.modalControl.click();
          }
        ));
  }
  comparaObjetos(arreglo, valor) {
    for (var i = 0; i < arreglo.length; i++) {
      if (arreglo[i].codEntidad === valor.codEntidad) {
        return true;
      }
    }
    return false;
  }

  compare(a, b) {

    const bandA = a.desEntidad.toUpperCase();
    const bandB = b.desEntidad.toUpperCase();

    let comparison = 0;
    if (bandA > bandB) {
      comparison = 1;
    } else if (bandA < bandB) {
      comparison = -1;
    }
    return comparison;
  }

  getServiciosDisponibles() {
    var todoEntidad = [];
    trackPromise(
      PagoServicioService.getServiciosDisponibles()
        .then((response) => {
          var data = JSON.stringify(response.data);

          var jsonData = JSON.parse(data);

          if (jsonData.codRetorno === '0') {
            var valores = jsonData.rubros;
            var options = [];
            valores.sort();
            options.push({
              value: undefined,
              label: "TODOS"
            });
            for (var x = 0; x < valores.length; x++) {
              options.push({
                value: valores[x],
                label:
                  valores[x],
              });
            }
            this.setState({ rubros: options });
            var jsonDataEntidad = JSON.parse(JSON.stringify(jsonData.entidad));

            var iter = 0;
            for (var i = 0; i < jsonDataEntidad.length; i++) {
              var jsonKeyEntidad = JSON.parse(JSON.stringify(jsonDataEntidad[i]));
              for (var j = 0; j < jsonKeyEntidad.length; j++) {
                var jsonKey = JSON.parse(JSON.stringify(jsonKeyEntidad[j]));
                if (!this.comparaObjetos(todoEntidad, jsonKey)) {
                  todoEntidad[iter] = jsonKey;
                  iter++;
                }
              }
            }
            todoEntidad.sort(this.compare);

            this.setState({ entidades: todoEntidad, entidadesFiltrado: todoEntidad });
          }
          else {

            Popup.queue(this.notifiPopup("Error", jsonData.desRetorno));
            return;
          }
        }, error => {
          const resMessage = error.desRetorno;
          this.setState({
            loading: false,
            message: resMessage
          });
          //   this.modalControl.click();
        }
        ));
  }




  handleChangeSelector = (selectedOption) => {
    this.setState({ selectedOption });
    this.getServiciosDisponibles();

  };


  handleChangeSelectorRubro = (selectedRubro) => {


    var rubro = selectedRubro.value
    this.setState({ selectedRubro, valorRubroSelected: rubro, entidadesFiltrado: this.selectorRubro(rubro) });
    // this.setState({ entidadesFiltrado: this.selectorRubro(rubro) });

  };


  selectorRubro = (rubro) => {

    var filtrado = [];
    var filtradoServ = [];
    var iter = 0;
    var buscar = document.getElementById("inputEntidad").value

    if (rubro === undefined && buscar === "")
      return this.state.entidades;
    if (rubro === undefined && buscar !== "") {

      for (var i = 0; i < this.state.entidades.length; i++) {
        var datos = JSON.parse(JSON.stringify(this.state.entidades[i]));

        if (datos.desEntidad.toUpperCase().includes(buscar.toUpperCase())) {

          filtradoServ[iter] = datos;
          iter++;

        }
      }
      filtrado = filtradoServ;
      return filtrado;
    }


    for (var x = 0; x < this.state.entidades.length; x++) {
      var datoFiltrado = JSON.parse(JSON.stringify(this.state.entidades[x]));
      for (var j = 0; j < datoFiltrado.servicio.length; j++) {
        var datoServicio = JSON.parse(JSON.stringify(datoFiltrado.servicio[j]));
        if (datoServicio.rubro.toUpperCase() === rubro.toUpperCase()) {

          filtrado[iter] = datoFiltrado;
          iter++;
          break;
        }

      }
    }


    if (buscar !== "") {
      var filtradoServicios = [];
      var iterador = 0;


      for (var k = 0; k < filtrado.length; k++) {
        var dat = JSON.parse(JSON.stringify(filtrado[k]));

        if (dat.desEntidad.toUpperCase().includes(buscar.toUpperCase())) {

          filtradoServicios[iterador] = dat;
          iterador++;

        }
      }
      filtrado = filtradoServicios;
    }


    return filtrado;

  };

  handleChangeServicio = (servicio) => {

    if (servicio === "" && this.state.valorRubroSelected === undefined) {
      this.setState({ entidadesFiltrado: this.state.entidades, servicioSearch: undefined });
    }
    else {

      if (servicio !== "" && this.state.valorRubroSelected === undefined) {
        this.setState({ entidadesFiltrado: this.selectorServicio(servicio), servicioSearch: servicio });
      }
      if (servicio !== "" && this.state.valorRubroSelected !== undefined) {

        this.setState({ entidadesFiltrado: this.selectorServicioRubro(servicio), servicioSearch: servicio });
      }
      if (servicio === "" && this.state.valorRubroSelected !== undefined) {

        this.setState({ entidadesFiltrado: this.selectorRubro(this.state.valorRubroSelected), servicioSearch: undefined });
      }
    }
  };


  selectorServicio = (serv) => {
    var filtradoServ = [];
    var iter = 0;
    for (var i = 0; i < this.state.entidades.length; i++) {
      var datos = JSON.parse(JSON.stringify(this.state.entidades[i]));

      if (datos.desEntidad.toUpperCase().includes(serv.toUpperCase())) {

        filtradoServ[iter] = datos;
        iter++;

      }
    }

    return filtradoServ;

  };

  selectorServicioRubro = (serv) => {
    var filtradoServ = [];
    var iter = 0;
    var filtradoRubros = this.selectorRubro(this.state.valorRubroSelected);
    for (var i = 0; i < filtradoRubros.length; i++) {
      var datos = JSON.parse(JSON.stringify(filtradoRubros[i]));

      if (datos.desEntidad.toUpperCase().includes(serv.toUpperCase())) {

        filtradoServ[iter] = datos;
        iter++;

      }
    }

    return filtradoServ;

  };


  serviciosPago(servicio) {

    var valor = JSON.parse(JSON.stringify(servicio));
    return valor;

  }

  selectorValue = (dataFromChild, item, path) => {

    this.setState({
      valor: dataFromChild,
      itemSelected: item,
      servicios: dataFromChild,
      pathEntidad: path,
    });

    if (dataFromChild.length === 1) {

      this.selectorValuePopUp(null, dataFromChild[0].desServicio, dataFromChild[0].codServicio, dataFromChild[0].pathLogo, item)
      return;
    }
    this.modalControl.click();


  };


  selectorValuePopUp = (dataFromChild, desServicio, codigo, img, entidad) => {

    sessionStorage.setItem("servicio", codigo);
    sessionStorage.setItem("nombre", desServicio);
    sessionStorage.setItem("img", img);
    sessionStorage.setItem("entidad", entidad);
    //history.push('/pronet');
    history.push(ConfigService.getPathByName("pronet")?.url);
    window.location.reload();

  };

  render() {

    var ent = this.state.entidadesFiltrado
    
    return (
      <div className="content-wrapper">
        <Titulo texto="Pago de Servicios Publicos y Privados - Pronet" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header" style={{ paddingBottom: 20 }}>
                    <div className="row">
                      <div className="col-md-2">
                        <br />
                        <b>Buscador Avanzado:</b>
                      </div>
                      <div className="col-md-5">
                        <label className="input-label">Categoría del servicio</label>
                        <Select key={this.state.selectedRubro}
                          value={this.state.selectedRubro}
                          onChange={this.handleChangeSelectorRubro}
                          options={this.state.rubros}
                          placeholder="TODOS"
                          noOptionsMessage={() => 'SIN DATOS'}
                        />
                      </div>
                      <div className="col-md-5">
                        <label className="input-label">Entidad</label>
                        <input id="inputEntidad" type="text" className="input-box form-control" name="inputEntidad"
                          onChange={(e) => { this.handleChangeServicio(e.currentTarget.value) }}
                        />
                      </div>
                    </div>
                  </div>
                  {/* CONTENEDOR DE SERVICIOS - INI*/}
                  <div className="card-body">
                    {/*<div className="row">
                      <div className="col-md-5">
                        <div className="form-group">
                          <label className="input-label-bold">Seleccione la Cuenta a Debitar *</label>
                          <Select
                            placeholder="Seleccionar la cuenta de Débito"
                            value={this.state.selectedOption}
                            onChange={this.handleChangeSelector}
                            options={this.state.optionsCuentas}

                            isClearable
                          />
                        </div>
                      </div>
                    </div>*/}
                    <div className="col-md-12 pago-servicio-listado">
                      <div className="row" >
                        {ent.map(elemento =>
                          <CardEntidad key={elemento.codEntidad}
                            img={elemento.pathLogo} label={elemento.desEntidad} codigo={elemento.codEntidad}
                            selectorValue={this.selectorValue.bind(this)}
                            itemSelected={elemento}
                          />
                        )}
                      </div>
                    </div>
                    {/* CONTENEDOR DE SERVICIOS - FIN*/}
                  </div>
                </div>
              </div>
            </div>

            <a ref={(a) => (this.modalControl = a)}
              href="#" className="pago-servicio-caja-link" data-toggle="modal" data-target="#modal-entidad">
              <PopupEntidadServicio idModal="modal-entidad" disponibles={this.state.servicios} titulo={this.state.itemSelected} imagen={this.state.pathEntidad} selectorValuePopUp={this.selectorValuePopUp.bind(this)} />
            </a>
          </div>
        </section>
      </div>

    );
  }
}